export default "__VITE_ASSET__IYoOSFtg__"